import { Box, Typography } from '@mui/material';
import React from 'react';
import DeviceFrame from './DeviceFrame';

/** Playwright flow screenshot (screenshots.json). */
export interface FlowScreenshotData {
    id: number;
    stage_name: string;
    stage_number: number;
    url_key: string;
    role: string;
    title: string;
    description: string;
    start: string | null;
    end: string | null;
}

/** Legacy manifest screenshot (program-steps.json). */
export interface ManifestScreenshotData {
    id: number;
    stage_name: string;
    stage_number: number;
    url_key: string;
    role: string;
    title: string;
    description: string;
    light_mobile: string | null;
    light_ipad: string | null;
    light_desktop: string | null;
    dark_mobile: string | null;
    dark_ipad: string | null;
    dark_desktop: string | null;
}

interface ScreenshotSlideProps {
    screenshot: FlowScreenshotData;
    visible: boolean;
}

const ScreenshotSlide: React.FC<ScreenshotSlideProps> = ({ screenshot, visible }) => {
    const panels = [
        { label: 'Start', url: screenshot.start },
        { label: 'End', url: screenshot.end },
    ].filter(p => p.url);

    return (
        <Box
            sx={{
                display: visible ? 'flex' : 'none',
                gap: 2,
                justifyContent: 'center',
                flexWrap: 'wrap',
                width: '100%',
            }}
        >
            {panels.map(({ label, url }) => (
                <Box key={label} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        {label}
                    </Typography>
                    <DeviceFrame device="mobile">
                        <Box
                            component="img"
                            src={url!}
                            alt={`${screenshot.title} (${label})`}
                            sx={{ width: '100%' }}
                        />
                    </DeviceFrame>
                </Box>
            ))}
        </Box>
    );
};

export default ScreenshotSlide;
